export default "/assets/website/images/szaloncuki.png?a93088878d44c55a480e7e404518bee8";